module.exports = __webpack_public_path__ + "static/media/showreel_background.1d9e766a.jpg";